import React from 'react';
export function priorityProp(fetchPriority) {
    // https://github.com/vercel/next.js/commit/68d5a3892b4edf1b62e3ece4ada324065a96b6f3
    // biome-ignore lint/suspicious/noExplicitAny: React.use is only available on React 19, react@canary and react@beta
    if (typeof React.use === 'function') {
        return { fetchPriority };
    }
    return { fetchpriority: fetchPriority };
}
const bogusBaseUrl = 'https://example.com/';
export const buildSrcSetFromSrc = (src, width, candidateMultipliers) => {
    if (!(src && width)) {
        return undefined;
    }
    return candidateMultipliers
        .map((multiplier) => {
        const url = new URL(src, bogusBaseUrl);
        if (multiplier !== 1) {
            url.searchParams.set('dpr', `${multiplier}`);
            const maxH = url.searchParams.get('max-h');
            const maxW = url.searchParams.get('max-w');
            if (maxH) {
                url.searchParams.set('max-h', `${Math.floor(Number.parseInt(maxH) * multiplier)}`);
            }
            if (maxW) {
                url.searchParams.set('max-w', `${Math.floor(Number.parseInt(maxW) * multiplier)}`);
            }
        }
        const finalWidth = Math.floor(width * multiplier);
        if (finalWidth < 50) {
            return null;
        }
        return `${url.toString().replace(bogusBaseUrl, '/')} ${finalWidth}w`;
    })
        .filter(Boolean)
        .join(',');
};
export function buildWebpSource(data, sizes) {
    var _a;
    return (data.webpSrcSet && (React.createElement("source", { srcSet: data.webpSrcSet, sizes: (_a = sizes !== null && sizes !== void 0 ? sizes : data.sizes) !== null && _a !== void 0 ? _a : undefined, type: "image/webp" })));
}
export function buildRegularSource(data, sizes, srcSetCandidates) {
    var _a, _b;
    return (React.createElement("source", { srcSet: (_a = data.srcSet) !== null && _a !== void 0 ? _a : buildSrcSetFromSrc(data.src, data.width, srcSetCandidates), sizes: (_b = sizes !== null && sizes !== void 0 ? sizes : data.sizes) !== null && _b !== void 0 ? _b : undefined }));
}
//# sourceMappingURL=utils.js.map